var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "span",
                [_vm._v("Заголовок ("), _c("TranslationIcon"), _vm._v(")")],
                1
              ),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.title,
                  "error-messages": _vm.errorMessages.title,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "title")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c("QuillEditorVue", {
            attrs: {
              cols: 12,
              content: _vm.listItem.data.description,
              loading: _vm.isLoading,
              disabled: _vm.isLoading,
              "light-mode": "",
            },
            on: {
              input: function ($event) {
                return _vm.mixChangeListItemHandler($event, "description")
              },
              onChangeContent: function ($event) {
                return _vm.mixChangeListItemHandler(
                  $event,
                  "descriptionForMobile"
                )
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "span",
                [
                  _vm._v("Заголовок кнопки ("),
                  _c("TranslationIcon"),
                  _vm._v(")"),
                ],
                1
              ),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.buttonTitle,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "buttonTitle")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Ссылка кнопки")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.buttonLink,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "buttonLink")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "", align: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "", align: "center" } },
                        [
                          _c("MediaFilePicker", {
                            attrs: {
                              multiple: false,
                              label: "Медиа файл",
                              isShowCaption: true,
                              "file-type": _vm.$options.mediaTypesByKeys.IMAGE,
                              value: _vm.listItem.data.image,
                              caption: _vm.listItem.data.caption,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.mixUploadImageHandler(
                                  $event,
                                  "image"
                                )
                              },
                              "change-caption": function ($event) {
                                return _vm.mixChangeListItemHandler(
                                  $event,
                                  "caption"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }